import { render, staticRenderFns } from "./CLocatorButton.vue?vue&type=template&id=108b3824&scoped=true&"
import script from "./CLocatorButton.vue?vue&type=script&lang=ts&"
export * from "./CLocatorButton.vue?vue&type=script&lang=ts&"
import style0 from "./CLocatorButton.vue?vue&type=style&index=0&id=108b3824&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108b3824",
  null
  
)

export default component.exports